export default __webpack_public_path__ + "static/media/background.959a834f.png";